<template>
  <div class="page">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>今日利润明细</span>
        <el-button type="text" @click="$router.push('/admin/dashboard')">返回仪表盘</el-button>
      </div>
      <el-form :inline="true" size="small">
        <el-form-item label="日期">
          <el-date-picker v-model="date" type="date" value-format="yyyy-MM-dd" :clearable="false" />
        </el-form-item>
        <el-form-item label="排序">
            <el-select v-model="sort" style="width: 140px">
            <el-option label="按时间" value="time" />
            <el-option label="按实收" value="revenue" />
            <el-option label="按成本" value="cost" />
            <el-option label="按毛利" value="profit" />
            <el-option label="按毛利率" value="rate" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="status" clearable placeholder="全部" style="width: 140px">
            <el-option label="已核算" value="accounted" />
            <el-option label="缺刊例" value="unaccounted" />
            <el-option label="非火山" value="non_volc" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="reload">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="loading" :data="list" border stripe>
        <el-table-column prop="createdAt" label="时间" width="170">
          <template slot-scope="{ row }">{{ formatTime(row.createdAt) }}</template>
        </el-table-column>
        <el-table-column prop="nickname" label="用户" min-width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.nickname || row.userId || '-' }}</template>
        </el-table-column>
        <el-table-column prop="credits" label="积分" width="80" align="right" />
        <el-table-column label="实收" width="100" align="right">
          <template slot-scope="{ row }">{{ formatYuan(row.revenueYuan) }}</template>
        </el-table-column>
        <el-table-column label="成本" width="100" align="right">
          <template slot-scope="{ row }">{{ formatYuan(row.costYuan) }}</template>
        </el-table-column>
        <el-table-column label="毛利" width="100" align="right">
          <template slot-scope="{ row }">{{ formatYuan(row.profitYuan) }}</template>
        </el-table-column>
        <el-table-column label="毛利率" width="90" align="right">
          <template slot-scope="{ row }">{{ rowRate(row) }}</template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="statusType(row.status)">{{ statusLabel(row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="pricedAs" label="计价" min-width="140" show-overflow-tooltip />
        <el-table-column prop="description" label="说明" min-width="160" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ formatOpsDescription(row.description) }}</template>
        </el-table-column>
      </el-table>
      <div class="pager-wrap">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page="page"
          @current-change="onPageChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { getOpsProfit } from '@/api/admin'
import { formatPercent, formatYuan } from '@/utils/dashboardFormat'
import { todayShanghai, formatDateTime, formatOpsDescription } from './opsFormat'

const STATUS_LABEL = {
  accounted: '已核算',
  unaccounted: '缺刊例',
  non_volc: '非火山'
}

export default {
  name: 'OpsProfit',
  data() {
    return {
      loading: false,
      date: todayShanghai(),
      sort: 'time',
      status: '',
      list: [],
      total: 0,
      page: 1,
      pageSize: 20
    }
  },
  created() {
    const query = this.$route.query || {}
    this.sort = 'time'
    if (query.status) this.status = String(query.status)
    if (query.sort) {
      const nextQuery = { ...query }
      delete nextQuery.sort
      this.$router.replace({ path: this.$route.path, query: nextQuery })
    }
    this.load()
  },
  methods: {
    formatYuan,
    formatTime: formatDateTime,
    formatOpsDescription,
    statusLabel(status) {
      return STATUS_LABEL[status] || status || '-'
    },
    statusType(status) {
      if (status === 'accounted') return 'success'
      if (status === 'non_volc') return 'info'
      return 'warning'
    },
    rowRate(row) {
      const revenue = Number(row.revenueYuan || 0)
      if (revenue <= 0) return '—'
      return formatPercent((Number(row.profitYuan || 0) * 100) / revenue)
    },
    onPageChange(page) {
      this.page = page
      this.load()
    },
    reload() {
      this.page = 1
      this.load()
    },
    async load() {
      this.loading = true
      try {
        const result = await getOpsProfit({
          date: this.date,
          page: this.page,
          size: this.pageSize,
          sort: this.sort || undefined,
          status: this.status || undefined
        })
        this.list = (result && result.list) || []
        this.total = (result && result.total) || 0
      } catch (e) {
        this.list = []
        this.total = 0
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pager-wrap {
  margin-top: 16px;
  text-align: right;
}
</style>
